/**
 * Client-safe access to the New Relic agent handle on `window`. Kept separate
 * from newrelic.ts so importers (e.g. the customer store) don't pull
 * `@newrelic/browser-agent` — which only resolves in the browser build — into
 * the shared module graph (VIP-12036).
 */

/**
 * Set the New Relic user id for session grouping. Call when the customer is known (e.g. after login).
 */
export function setNewRelicUserId(customerId: string | number | null): void {
  const setUserId = globalThis.window?.newrelic?.setUserId
  if (!setUserId) return
  setUserId(
    customerId !== null && customerId !== undefined ? String(customerId) : null
  )
}
